import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PhoneButton from '@/components/base/PhoneButton';

const stats = [
  { value: '10+', label: 'Yıllık Deneyim' },
  { value: '5000+', label: 'Mutlu Müşteri' },
  { value: '15 Dk', label: 'Ortalama Varış' },
  { value: '7/24', label: 'Kesintisiz Hizmet' },
];

const team = [
  {
    name: 'Ahmet Yıldız',
    role: 'Baş Çilingir Ustası',
    exp: '12 yıl deneyim',
    img: 'https://readdy.ai/api/search-image?query=professional%20Turkish%20male%20locksmith%20in%20work%20uniform%2C%20confident%20smile%2C%20tools%20in%20hand%2C%20workshop%20background%2C%20portrait%20photo&width=400&height=400&seq=team001&orientation=squarish',
  },
  {
    name: 'Mustafa Kara',
    role: 'Oto Çilingir Uzmanı',
    exp: '8 yıl deneyim',
    img: 'https://readdy.ai/api/search-image?query=professional%20Turkish%20male%20automotive%20locksmith%2C%20work%20uniform%2C%20car%20background%2C%20confident%20portrait%2C%20skilled%20technician&width=400&height=400&seq=team002&orientation=squarish',
  },
  {
    name: 'Emre Doğan',
    role: 'Çelik Kapı Uzmanı',
    exp: '6 yıl deneyim',
    img: 'https://readdy.ai/api/search-image?query=professional%20Turkish%20male%20locksmith%20specialist%2C%20work%20clothes%2C%20door%20background%2C%20friendly%20portrait%2C%20experienced%20worker&width=400&height=400&seq=team003&orientation=squarish',
  },
];

const values = [
  { icon: 'ri-shield-check-line', title: 'Güvenilirlik', desc: 'Tüm çilingirlerimiz kimlik doğrulamalı ve güvenilirdir.' },
  { icon: 'ri-timer-flash-line', title: 'Hız', desc: 'Çağrı aldıktan sonra ortalama 15 dakikada adresinizde oluyoruz.' },
  { icon: 'ri-hand-heart-line', title: 'Müşteri Odaklılık', desc: 'Her müşterimize özel, saygılı ve profesyonel hizmet sunuyoruz.' },
  { icon: 'ri-price-tag-3-line', title: 'Şeffaf Fiyat', desc: 'İşlem öncesi net fiyat bilgisi, gizli ücret yok.' },
];

export default function HakkimizdaPage() {
  useEffect(() => {
    document.title = 'Hakkımızda | Alfa Çilingir - 10 Yıllık Deneyimli Çilingir Firması';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Alfa Çilingir hakkında: 2014\'ten bu yana Beylikdüzü, Esenyurt, Büyükçekmece ve Bahçeşehir\'de 7/24 profesyonel çilingir hizmeti. 10+ yıl deneyim, 5000+ mutlu müşteri.');

    const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = `${siteUrl}/hakkimizda`;

    const existingScript = document.getElementById('schema-hakkimizda');
    if (existingScript) existingScript.remove();

    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'AboutPage',
          '@id': `${siteUrl}/hakkimizda#webpage`,
          url: `${siteUrl}/hakkimizda`,
          name: 'Hakkımızda | Alfa Çilingir',
          description: '2014\'ten bu yana İstanbul Avrupa Yakası\'nın güvenilir çilingir firması.',
          inLanguage: 'tr-TR',
        },
        {
          '@type': 'Organization',
          '@id': `${siteUrl}/#organization`,
          name: 'Alfa Çilingir',
          url: siteUrl,
          telephone: '+905416247982',
          foundingDate: '2014',
          address: {
            '@type': 'PostalAddress',
            addressLocality: 'Beylikdüzü',
            addressRegion: 'İstanbul',
            addressCountry: 'TR',
          },
          areaServed: ['Beylikdüzü', 'Esenyurt', 'Büyükçekmece', 'Bahçeşehir'],
          description: '10 yılı aşkın deneyimimizle İstanbul Avrupa Yakası\'nın en güvenilir çilingir firmasıyız.',
        },
        {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Ana Sayfa', item: siteUrl },
            { '@type': 'ListItem', position: 2, name: 'Hakkımızda', item: `${siteUrl}/hakkimizda` },
          ],
        },
      ],
    };

    const script = document.createElement('script');
    script.id = 'schema-hakkimizda';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('schema-hakkimizda');
      if (s) s.remove();
      const c = document.querySelector('link[rel="canonical"]');
      if (c) c.remove();
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-32 pb-16 bg-gray-900 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=locksmith%20team%20professional%20workers%20group%20photo%2C%20work%20uniforms%2C%20tools%2C%20workshop%20environment%2C%20Turkey%2C%20teamwork&width=1920&height=500&seq=apage001&orientation=landscape"
              alt="Alfa Çilingir Hakkımızda"
              className="w-full h-full object-cover object-top opacity-30"
            />
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 text-center">
            <span className="inline-flex items-center gap-2 text-orange-400 text-xs font-bold uppercase tracking-widest mb-4">
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-information-line"></i></span>
              Hakkımızda
            </span>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4">Alfa Çilingir Kimdir?</h1>
            <p className="text-gray-300 max-w-2xl mx-auto text-base md:text-lg">
              10 yılı aşkın deneyimimizle İstanbul Avrupa Yakası'nın en güvenilir çilingir firmasıyız.
            </p>
          </div>
        </section>

        {/* Story */}
        <section className="py-16 md:py-24 bg-stone-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="flex flex-col lg:flex-row gap-12 items-center">
              <div className="lg:w-1/2">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20locksmith%20workshop%20interior%2C%20tools%20organized%20on%20wall%2C%20keys%20hanging%2C%20clean%20professional%20workspace%2C%20Istanbul%20Turkey%2C%20warm%20lighting&width=700&height=500&seq=about001&orientation=landscape"
                  alt="Alfa Çilingir Atölyesi"
                  className="w-full h-80 lg:h-96 object-cover object-top rounded-2xl"
                />
              </div>
              <div className="lg:w-1/2">
                <span className="inline-flex items-center gap-2 text-orange-500 text-xs font-bold uppercase tracking-widest mb-4">
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-history-line"></i></span>
                  Hikayemiz
                </span>
                <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
                  10 Yıldır İstanbul'un Güvenilir Çilingiri
                </h2>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">
                  Alfa Çilingir, 2014 yılında Beylikdüzü'nde küçük bir atölye olarak kuruldu. Kuruluşumuzdan bu yana müşteri memnuniyetini her şeyin önünde tutarak büyüdük ve İstanbul Avrupa Yakası'nın en güvenilir çilingir firması haline geldik.
                </p>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">
                  Bugün Beylikdüzü, Esenyurt, Büyükçekmece ve Bahçeşehir'in tüm mahalle ve semtlerinde 7/24 hizmet veriyoruz. Deneyimli ve lisanslı çilingir ekibimizle acil kapı açma, kilit değiştirme, çelik kapı açma, oto çilingir ve kasa açma hizmetleri sunuyoruz.
                </p>
                <p className="text-gray-500 text-sm leading-relaxed mb-6">
                  Her müşterimize saygılı, hızlı ve şeffaf fiyatlarla hizmet vermeyi ilke edindik. Gizli ücret yok, söz verilen sürede geliyoruz.
                </p>
                <PhoneButton size="md" />
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-12 bg-orange-500">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <p className="text-4xl md:text-5xl font-extrabold text-white mb-1">{s.value}</p>
                  <p className="text-orange-100 text-sm">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="py-16 md:py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="text-center mb-12">
              <span className="inline-flex items-center gap-2 text-orange-500 text-xs font-bold uppercase tracking-widest mb-3">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-heart-line"></i></span>
                Değerlerimiz
              </span>
              <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">Bizi Farklı Kılan Değerler</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {values.map((v) => (
                <div key={v.title} className="bg-stone-50 rounded-2xl p-6 border border-stone-100 text-center">
                  <span className="w-14 h-14 flex items-center justify-center bg-orange-50 text-orange-500 rounded-2xl mx-auto mb-4">
                    <i className={`${v.icon} text-2xl`}></i>
                  </span>
                  <h3 className="font-bold text-gray-900 mb-2">{v.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Team */}
        <section className="py-16 md:py-24 bg-stone-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="text-center mb-12">
              <span className="inline-flex items-center gap-2 text-orange-500 text-xs font-bold uppercase tracking-widest mb-3">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-team-line"></i></span>
                Ekibimiz
              </span>
              <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">Uzman Çilingir Ekibimiz</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
              {team.map((member) => (
                <div key={member.name} className="bg-white rounded-2xl overflow-hidden border border-stone-100 text-center">
                  <div className="w-full h-52">
                    <img
                      src={member.img}
                      alt={member.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-5">
                    <h3 className="font-bold text-gray-900 text-base">{member.name}</h3>
                    <p className="text-orange-500 text-xs font-semibold mt-1">{member.role}</p>
                    <p className="text-gray-400 text-xs mt-1">{member.exp}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 bg-orange-500">
          <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
            <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-3">Hizmetimizden Yararlanmak İster misiniz?</h2>
            <p className="text-orange-100 mb-6">7/24 hizmetinizdeyiz. Hemen arayın.</p>
            <a
              href="tel:05416247982"
              className="inline-flex items-center gap-3 bg-white text-orange-500 font-extrabold px-8 py-4 rounded-full whitespace-nowrap cursor-pointer hover:bg-orange-50 transition-all duration-200 text-lg"
            >
              <span className="w-6 h-6 flex items-center justify-center"><i className="ri-phone-fill text-xl"></i></span>
              0541 624 79 82
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
